import { message } from 'antd';
import { useQuestionStatistic } from '../../../../../hooks/api/questionStatistic';
import { DefaultFetchError, getMessageInError } from '../../../../../hooks/fetch';

export const useQuestionStatistics = () => {
  const questionStatistic = useQuestionStatistic();

  const getQuestionStatistic = (subCategoryId: string) => {
    questionStatistic.fetch({
      subCategoryId,
    })
      .catch((error: DefaultFetchError) => {
        message.error(getMessageInError(error));
      });
  };

  return {
    getQuestionStatistic,
    response: questionStatistic.response,
    loading: questionStatistic.loading,
    error: questionStatistic.error,
  };
};

export default {
  useQuestionStatistics,
};
